import { notifyPdfLoadedSection } from '../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../PDFRenderer/PDFRendererTypes';

export const RECEIVE_DATA = 'PROJECTED_CASH_FLOW.RECEIVE_DATA',
  SET_ERRORS = 'PROJECTED_CASH_FLOW.SET_ERRORS',
  SET_ERROR_TYPE = 'PROJECTED_CASH_FLOW.SET_ERROR_TYPE',
  SET_CURRENT = 'PROJECTED_CASH_FLOW.SET_CURRENT';

export const receive_data = (resp_data, clientId) => ({
  type: RECEIVE_DATA,
  clientId,
  resp_data,
});

export const set_errors = (errors, clientId) => ({
  type: SET_ERRORS,
  errors,
  clientId,
});

export const set_error_type = (error_type, clientId) => ({
  type: SET_ERROR_TYPE,
  error_type,
  clientId,
});

export const set_current = (is_current, clientId) => ({
  type: SET_CURRENT,
  is_current,
  clientId,
});

export const fetch_data = (mode, clientId, fpId, IsPdf, expandCurrentYear) => {
  return dispatch => {
    ADV.util
      .request({
        uri: 'Consumer/ProjectedCashFlowReport',
        data: {
          mode,
          clientId,
          fpId,
          IsPdf,
          expandCurrentYear,
        },
      })
      .then(resp => {
        if (resp.success) {
          dispatch(receive_data(resp.payload.viewData, clientId));
          dispatch(notifyPdfLoadedSection(PdfSectionType.ProjectedCashflow));
        } else {
          dispatch(set_error_type(resp.errorType, clientId));
          dispatch(set_errors(resp.errors, clientId));
        }
      })
      .catch(err => dispatch(set_errors(err, clientId)));
  };
};
